export default (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 512 512">
    <rect width="512" height="512" rx="15%" fill="#5f01d1" />
    <g fill="#fff">
      <circle cx="406" cy="252" r="43" />
      <path d="M188 137l60 137 56-137h88l-138 307h-88l42-92-102-215z" />
    </g>
  </svg>
);
